import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { ClientCommentDialog } from '~/components/CommentCell/ClientCommentDialog.tsx';
import {
  CLIENT_COMMENT_LABELS,
  COMMENT_EMPTY_PLACEHOLDER,
} from '~/components/CommentCell/constants.ts';
import { commentCellStyles } from '~/components/CommentCell/styles.ts';
import { getCommentPlainText } from '~/components/CommentCell/utils.ts';

interface IClientCommentCellProps {
  initialComment?: string;
}

export const ClientCommentCell: React.FC<IClientCommentCellProps> = ({ initialComment }) => {
  const [open, setOpen] = useState(false);
  const commentText = getCommentPlainText(initialComment);
  const hasComment = !!commentText.trim();

  if (!hasComment) {
    return (
      <Typography variant="caption" color="text.disabled">
        {COMMENT_EMPTY_PLACEHOLDER}
      </Typography>
    );
  }

  return (
    <>
      <Box
        onClick={(event) => {
          event.stopPropagation();
          setOpen(true);
        }}
        sx={commentCellStyles.clientCell}
      >
        <Box sx={commentCellStyles.clientCellContent}>
          <Typography variant="body2" color="text.primary" sx={commentCellStyles.clientCellText}>
            {commentText}
          </Typography>
          <Typography
            component="span"
            className="comment-details-button"
            sx={commentCellStyles.clientDetailsButton}
          >
            {CLIENT_COMMENT_LABELS.details}
          </Typography>
        </Box>
      </Box>

      <ClientCommentDialog
        initialComment={initialComment}
        open={open}
        onClose={() => setOpen(false)}
      />
    </>
  );
};
